import PromiseItem from './PromiseItem';

export default PromiseItem;
